import axios from 'axios'

export default {
    // Lista completa de municípios do Brasil (IBGE) — alimenta o autocomplete unificado
    getMunicipiosIBGE() {
        return axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios?view=nivelado');
    },
    // Cidades de um estado com latitude/longitude
    getCidades(idUF) {
        return axios.get(`${process.env.VUE_APP_API_GEO_LOCATION}/api/nearbyCities/estado?idUF=${idUF}`);
    },
    // Cidades mais próximas de uma coordenada (usado na geolocalização do usuário)
    getNearbyCities(lat, lng) {
        return axios.get(`${process.env.VUE_APP_API_GEO_LOCATION}/api/nearbyCities?lat=${lat}&lng=${lng}`);
    },
}
